import { DisplayAdSlotDivNames } from '../framework/dfp/ad-config/slot-configs';
import { BingSlotDivNames } from '../framework/bing/client-side/ad-slots';

export const externalTagsPlaceholderDivId = 'third-party-script-controlled-tags';

export const getAllIdsOfExternallyPopulatedTags = () =>
    Object.values({ ...BingSlotDivNames, ...DisplayAdSlotDivNames });
